import { render, staticRenderFns } from "./AutocompleteRegiao.vue?vue&type=template&id=d66c33e4&"
import script from "./AutocompleteRegiao.vue?vue&type=script&lang=js&"
export * from "./AutocompleteRegiao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports